import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';

export interface negotiationCountState {
  countNum: {
    [key: string]: string | number;
  };
}

export const initialNegotiationCountState: negotiationCountState = {
  // Stateの初期値
  countNum: {
    negotiationTotal: '--',
    customerTotal: '--',
    noneNegotiation: '--',
    noneProduct: '--',
    doing: '--',
    pending: '--',
    done: '--',
    customerDoing: '--',
    customerPending: '--',
    customerDone: '--',
  },
};

export const negotiationCountReducer = reducerWithInitialState(initialNegotiationCountState).case(
  actions.fetchNegotiationCount,
  (state: negotiationCountState, payload: negotiationCountState) => {
    return payload;
  }
);
